export default __webpack_public_path__ + "static/media/eventOrganizer.65445633.jpg";